import { render } from "./Widget1.vue?vue&type=template&id=4cd98634"
import script from "./Widget1.vue?vue&type=script&lang=ts"
export * from "./Widget1.vue?vue&type=script&lang=ts"
script.render = render

export default script